<div class="container" *ngIf="currentClient">

    <div class="row mb-2">
        <div class="display-flex flex-row align-items-center justify-content-between w-100">
            <label><strong>Pledge History For:</strong>
                {{ currentClient.prefix }} {{ currentClient.firstName }} {{ currentClient.middleInitial }} {{ currentClient.lastName }} {{ currentClient.suffix }}
            </label>
            <div class="display-flex flex-column">
                <a [routerLink]="['../pledge/add']" class="btn btn-primary mb-xs new-button"
                   [class.disabled]="!isClientValid()">
                    New Pledge
                </a>
                <span *ngIf="!isClientValid()" class="text-danger">This Client Has Missing Info</span>
            </div>
        </div>
    </div>
    <div class="row">
        <table class="table table-striped table-hover">
            <thead>
            <tr>
                <th class="text-xs-center">Pledge Amount</th>
                <th class="text-xs-center">Pledge Status</th>
                <th class="text-xs-center">Paid Date</th>
                <th class="text-xs-center">Fund Type</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let item of currentClientPledgeList">
                <td class="text-xs-center"><a class="clickable text-primary"
                                              [routerLink]="['/app/pledge/', item.id]">{{item.pledgedAmount | parseNumber | currency:'USD':'symbol':'1.2-2'}}</a>
                </td>
                <td class="text-xs-center"
                    [class.has-danger]="item.status == 'Deleted'">{{formatPledgeStatus(item.status)}}</td>
                <td class="text-xs-center">{{item.paidDate ? (item.paidDate | moment: 'L') : 'Not Paid'}}</td>
                <td class="text-xs-center">{{formatPledgeTypeName(item.pledgeTypeId)}}</td>
            </tr>
            </tbody>
        </table>
    </div>
    </div>
